<div class="panel py-1 my-auto">
    <div class="panel-body py-0">
        <div class="d-inline-flex row justify-content-between">
            <div class="d-inline-flex row mr-1 p-1">
                <app-tooltip
                    appCustomPopover
                    placement="top"
                    popoverText="{{tooltipText}}"
                >
                    <ng-container icon>
                        <app-toggle class="my-auto mx-0" (change)="toggleChange(null, false)"
                                    [disable]="toggleDisabled">
                        </app-toggle>
                    </ng-container>
                </app-tooltip>
                @if (toggleValue) {
                    <p class="my-auto mx-0">{{ 'RIDE_SHARING_ENABLED' | translate }}</p>
                } @else {
                    <p class="my-auto mx-0">{{ 'RIDE_SHARING_DISABLED' | translate }}</p>
                }
            </div>
            @if (toggleValue) {
                <div class="d-inline-flex row mx-1">
                    <p class="my-auto">⁝</p>
                    <div class="d-inline-flex row ml-1 my-0 p-2 bar border-0 rounded-10"
                         [ngClass]="{'bar-error': !rideSharingDriversCount || !rideSharingPassengersCount}">
                        @if (!rideSharingPassengersCount || !rideSharingDriversCount) {
                            <app-tooltip
                                appCustomPopover
                                placement="top"
                                popoverText="RIDE_SHARING_ENABLED_WARNING"
                                class="m-auto"
                            >
                                <ng-container icon>
                  <span
                      class="vismaicon vismaicon-filled vismaicon-error vismaicon-sm">
                  </span>
                                </ng-container>
                            </app-tooltip>
                        }
                        <span class="mx-1 pl-2 pr-2 bar-value border-0 rounded-5"
                              [ngClass]="{
                        'bar-value-clear':rideSharingDriversCount > 0
                    }">{{ rideSharingDriversCount }}</span>
                        <p class="my-0">{{ 'RIDE_SHARING_BAR_DRIVERS' | translate }}</p>
                        <span class="mx-1 pl-2 pr-2 bar-value border-0 rounded-5"
                              [ngClass]="{
                        'bar-value-clear':rideSharingPassengersCount > 0
                    }">{{ rideSharingPassengersCount }}</span>
                        <p class="my-0">{{ 'RIDE_SHARING_BAR_PASSENGERS' | translate }}</p>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
